import {createLazyFileRoute} from '@tanstack/react-router'

import Checkout from '@/views/Checkout/Checkout'

export const Route = createLazyFileRoute('/_shop/checkout/$result/')({
  component: Checkout,
})
